import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import { toggleEditMode } from '../modules/app/controls/controls.action';
import FormatService from '../services/format-service';
import { QUERY_PARAM_EDIT_MODE } from '../constants/system/query-params';

const useEditModeQuery: Function = (isDisabled: boolean): void => {
  const [isRendered, setIsRendered]: [boolean, Function] = useState(false);

  const dispatch: ReduxDispatch = useDispatch();
  const navigate: ReactRouterNavigate = useNavigate();
  const location: ReactRouterLocation = useLocation();
  const isEditMode: boolean = useSelector(({ controls }: Reducers): boolean => controls.isEditMode);

  const locationPathname: string = location.pathname;
  const locationQueryParams: ParsedQueryParams | null = FormatService.parseQueryParams(location.search);
  const withLocationParam: boolean = !!locationQueryParams && !!locationQueryParams[QUERY_PARAM_EDIT_MODE];

  const changeEditModeQuery: Function = useCallback((): void => {
    if (isDisabled) {
      return;
    }

    const newLocationQueryParams: ParsedQueryParams = locationQueryParams
    && Object.keys(locationQueryParams).length ? {
      ...locationQueryParams,
    } : {};

    if (!isEditMode) {
      delete newLocationQueryParams[QUERY_PARAM_EDIT_MODE];
    } else {
      newLocationQueryParams[QUERY_PARAM_EDIT_MODE] = FormatService.BOOLEAN_VALUE_TRUE;
    }

    if ((isEditMode && !withLocationParam) || (!isEditMode && withLocationParam)) {
      navigate({
        pathname: locationPathname,
        search: FormatService.formatQueryParams(newLocationQueryParams),
        preventScrollReset: true,
      });
    }
  }, [isDisabled, locationQueryParams, locationPathname, isEditMode, withLocationParam]);

  useEffect((): void => {
    if (isRendered) {
      changeEditModeQuery();
    } else {
      setIsRendered(true);
    }
  }, [isEditMode]);

  useEffect((): void => {
    if (isEditMode !== withLocationParam) {
      dispatch(toggleEditMode(withLocationParam));
    }
  }, [withLocationParam]);
};

export default useEditModeQuery;
